export enum CatalogItemLocation {
    Listing = `Catalog Grid`,
    ProductCard = `Product Card`,
    SalesSection = `Sale Timers`,
    NewProductsSection = `New Goods`,
    SalesPage = `Sales`,
    Cart = `Cart`,
    FavoritesPage = `Favorites`,
    Popular = `Popular products`,
    Variants = `Multi Card`,
    ComparePage = `Compare Row`,
    BasketPageMain = `Basket Grid`,
    BasketPageAccessories = `Basket Accessories`,
    ProductPageAccessories = `Product Accessories`,
    SearchPopup = `Search Clue`,
    SearchResults = `Search Results`,
    ServicesCart = `Services cart`,
    PopularProduct = ``,
    AccessoriesCart = `Accessories car`,
    None = `not set`,
}

export enum ProductType {
    Service = `service`,
    Accessory = `accessory`,
    Product = `product`,
    TradeIn = `tradein`,
    Total = `total`,
}